import { playFocus } from 'app/ui-components/utils.styles';
import styled, { css } from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { fontWeightBold, fontWeightRegular, regularWhite } from '../../../../ui-components/design-tokens';
import { playFontSize } from '../../../../ui-components/typography/helpers';

export const ProgramInfoTitle = styled.h1`
    display: inline-block;
    vertical-align: middle;
    overflow-x: hidden;
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;

    ${playFontSize(1.2)}

    @media ${device.GteSmall} {
        ${playFontSize(1.6)};
    }
`;

const CommonLinkStyles = css`
    text-decoration: none;
    color: ${regularWhite};
    line-height: 1.4;
    text-transform: uppercase;

    &:hover {
        text-decoration: underline solid #ffffff 1px;
    }

    ${playFocus()}
`;

export const ProgramInfoTitleLink = styled.a`
    ${CommonLinkStyles}
    font-weight: ${fontWeightBold};
`;

export const ProgramInfoEpisodeLink = styled.a`
    ${CommonLinkStyles}
    font-weight: ${fontWeightRegular};
`;

export const ProgramInfoDivider = styled.span`
    text-decoration: none;
    display: inline;

    &:after {
        content: ': ';
        font-weight: ${fontWeightBold};
    }
`;
